import React from 'react';
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from '@mui/material/InputLabel';
import { TextField, Autocomplete, styled } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { NZ } from './NZRegions'
const regionsAndCities = NZ
const FlexContainer = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    width: "100%"
});
const CascadeSelection = ({ region, setRegion, city, setCity, onChange }) => {
    const handleRegionChange = (event) => {
        setRegion(event.target.value);
        setCity('');
    };

    const handleCityChange = (event) => {
        setCity(event.target.value);
    };

    React.useEffect(() => {
        onChange(region, city);
    }, [region, city]);

    return (
        <FlexContainer>
            <FormControl sx={{ minWidth: '50%' }}>
                <InputLabel id="Region">Choose Region</InputLabel>
                <Select value={region} onChange={handleRegionChange} sx={{ flexBasis: '50%' }} label='Choose Region' defaultValue={'region'}>
                    <MenuItem value="region" disabled>
                        Choose Region
                    </MenuItem>
                    {Object.keys(regionsAndCities).map((region) => (
                        <MenuItem value={region}>{region}</MenuItem>
                    ))}
                    <MenuItem value={''}>{'All Region'}</MenuItem>
                </Select>
            </FormControl>
            <FormControl sx={{ minWidth: '50%' }}>
                <InputLabel id="City">Choose City</InputLabel>
                <Select value={city} onChange={handleCityChange} sx={{ flexBasis: '50%', marginLeft: '5px' }} label='Choose City' defaultValue={'city'}>
                    <MenuItem value="city" disabled>
                        Choose City
                    </MenuItem>
                    {regionsAndCities[region] && regionsAndCities[region].map((city) => (
                        <MenuItem value={city}>{city}</MenuItem>
                    ))}
                    <MenuItem value={''}>{'All City'}</MenuItem>
                </Select>
            </FormControl >
            {/* {region && (
                <FormControl sx={{ minWidth: '50%' }}>
                    <InputLabel id="City">Choose City</InputLabel>
                    <Select value={city} onChange={handleCityChange} sx={{ flexBasis: '50%', marginLeft: '5px' }} label='Choose City' defaultValue={'city'}>
                        <MenuItem value="city" disabled>
                            Choose City
                        </MenuItem>
                        {regionsAndCities[region].map((city) => (
                            <MenuItem value={city}>{city}</MenuItem>
                        ))}
                    </Select>
                </FormControl >


            )} */}
        </FlexContainer>
    );
};
export default CascadeSelection